/* Melinava Kollektionsseite: Filtern, Sortieren und Nachladen ohne Seitenwechsel (Section Rendering API),
   Fenster von unten auf dem Handy, Banner-X mit Cookie (30 Tage). Gehört zu sections/mv-kollektion.liquid. */
(function () {
  var COOKIE = 'mv_lieferhinweis=zu';

  function root() { return document.querySelector('[data-mvk]'); }

  // Behält Parameter wie view (Vorschau) bei, ersetzt alles, was Filter, Sortierung und Seite betrifft.
  function buildUrl(params) {
    var cur = new URLSearchParams(location.search), out = new URLSearchParams();
    cur.forEach(function (v, k) { if (k.indexOf('filter.') !== 0 && k !== 'sort_by' && k !== 'page') out.append(k, v); });
    params.forEach(function (v, k) { if (v !== '') out.append(k, v); });
    var q = out.toString();
    return location.pathname + (q ? '?' + q : '');
  }
  function formParams(form) {
    var p = new URLSearchParams();
    new FormData(form).forEach(function (v, k) { if (v !== '' && k !== 'mvk-sortsheet') p.append(k, v); });
    return p;
  }
  function withSection(url, id) { return url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + encodeURIComponent(id); }
  function keepView(href) {
    var u = new URL(href, location.href), view = new URLSearchParams(location.search).get('view');
    if (view && !u.searchParams.get('view')) u.searchParams.set('view', view);
    return u.pathname + u.search;
  }
  function fetchSection(url) {
    var r = root();
    return fetch(withSection(url, r.dataset.sectionId)).then(function (res) { return res.text(); })
      .then(function (t) { return new DOMParser().parseFromString(t, 'text/html').querySelector('[data-mvk]'); });
  }
  function load(url, push) {
    var r = root(); r.classList.add('is-loading');
    return fetchSection(url).then(function (fresh) {
      if (!fresh) { location.href = url; return; }
      r.replaceWith(fresh);
      if (push) history.replaceState(null, '', url);
      if (document.cookie.split('; ').indexOf(COOKIE) > -1) { var b = fresh.querySelector('[data-mvk-ban]'); if (b) b.remove(); }
    }).catch(function () { location.href = url; });
  }

  function openSheet(name) {
    var s = root().querySelector('[data-mvk-sheet="' + name + '"]'); if (!s) return;
    s.hidden = false; document.documentElement.style.overflow = 'hidden';
    var f = s.querySelector('header button'); if (f) f.focus();
  }
  function closeSheets() {
    root().querySelectorAll('[data-mvk-sheet]').forEach(function (s) { s.hidden = true; });
    document.documentElement.style.overflow = '';
  }
  var countTimer;
  function updateCount() {
    var r = root(), form = r.querySelector('[data-mvk-sheetform]'), n = r.querySelector('[data-mvk-n]');
    clearTimeout(countTimer);
    countTimer = setTimeout(function () {
      fetchSection(buildUrl(formParams(form))).then(function (fresh) { if (fresh && n) n.textContent = fresh.dataset.count; });
    }, 150);
  }

  document.addEventListener('change', function (e) {
    var t = e.target, r = root(); if (!r || !r.contains(t)) return;
    if (t.closest('[data-mvk-form]')) { load(buildUrl(formParams(t.closest('[data-mvk-form]'))), true); return; }
    if (t.closest('[data-mvk-sheetform]')) { updateCount(); return; }
    if (t.matches('[data-mvk-sortradio]')) {
      var p = formParams(r.querySelector('[data-mvk-form]')); p.set('sort_by', t.value);
      closeSheets(); load(buildUrl(p), true);
    }
  });

  document.addEventListener('click', function (e) {
    var t = e.target, r = root(); if (!r || !r.contains(t)) return;
    var x;
    if ((x = t.closest('[data-mvk-ban-close]'))) {
      try { document.cookie = COOKIE + '; max-age=2592000; path=/; SameSite=Lax'; } catch (err) {}
      var b = r.querySelector('[data-mvk-ban]'); if (b) b.remove(); return;
    }
    if ((x = t.closest('[data-mvk-chip]'))) {
      var p = formParams(r.querySelector('[data-mvk-form]'));
      p.delete(x.dataset.param); if (x.dataset.value) p.append(x.dataset.param, x.dataset.value);
      load(buildUrl(p), true); return;
    }
    if ((x = t.closest('[data-mvk-open]'))) { openSheet(x.dataset.mvkOpen); return; }
    if (t.closest('[data-mvk-close]') || t.matches('.mvk-sheetbg')) { closeSheets(); return; }
    if (t.closest('[data-mvk-sheetreset]')) {
      var f = r.querySelector('[data-mvk-sheetform]');
      f.querySelectorAll('input[type=checkbox]').forEach(function (i) { i.checked = false; });
      f.querySelectorAll('input[type=radio][value=""]').forEach(function (i) { i.checked = true; });
      updateCount(); return;
    }
    if (t.closest('[data-mvk-apply]')) { closeSheets(); load(buildUrl(formParams(r.querySelector('[data-mvk-sheetform]'))), true); return; }
    if ((x = t.closest('a[data-mvk-link]'))) { e.preventDefault(); load(keepView(x.href), true); return; }
    if ((x = t.closest('[data-mvk-next]'))) {
      e.preventDefault(); x.textContent = x.dataset.mvkLaden || 'Wird geladen ...';
      fetchSection(keepView(x.href)).then(function (fresh) {
        if (!fresh) { location.href = x.href; return; }
        var grid = r.querySelector('[data-mvk-grid]');
        fresh.querySelectorAll('[data-mvk-grid] > *').forEach(function (c) { grid.appendChild(c); });
        var more = r.querySelector('[data-mvk-more]'), nm = fresh.querySelector('[data-mvk-more]');
        if (nm) more.replaceWith(nm); else more.remove();
      });
    }
  });

  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && root()) closeSheets(); });
})();
